// Tiny renderer for our content convention: text wrapped in *single asterisks*
// becomes <em>. Used for principle/description/why blocks in the framework data.

import { Fragment, type ReactNode } from 'react';

export function renderEmphasis(input: string): ReactNode {
  return input.split('*').map((part, i) =>
    i % 2 === 1 ? (
      <em key={i} className="italic text-asphalt font-normal">
        {part}
      </em>
    ) : (
      <Fragment key={i}>{part}</Fragment>
    )
  );
}
